import { endOfDay, format, isSameDay, startOfDay } from "date-fns";

/** Calendar selections use the browser timezone; calculate anew for each request. */
export function getRequestDateRange(from?: Date, to?: Date) {
  const now = new Date();
  const end = to || now;

  return {
    startDate: format(startOfDay(from || now), "yyyy-MM-dd HH:mm:ss"),
    endDate: format(isSameDay(end, now) ? now : endOfDay(end), "yyyy-MM-dd HH:mm:ss"),
  };
}
